// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabstrip_wrapper__w3BC1","tab":"Tabstrip_tab__pAi9z","tabActive":"Tabstrip_tabActive__jOsDf"};